(() => {
  const instances = new Map();
  const selector = '[data-nyxel-summary]';
  function mount(root) {
    if (instances.has(root)) return;
    const list = root.querySelector('.UltraDetailBlock--price .ProductMeta__PriceList');
    if (!list) return;
    function refresh() {
      const prices = [...list.querySelectorAll(':scope > .Price')];
      for (const price of prices) {
        const label = price.textContent.trim().replace(/\s+[A-Z]{3}\s*$/, '');
        if (price.dataset.nyxelPriceLabel !== label) price.dataset.nyxelPriceLabel = label;
      }
      const current = prices.find(price => !price.classList.contains('Price--compareAt'));
      const compare = prices.find(price => price.classList.contains('Price--compareAt'));
      const amount = element => Number((element?.textContent || '').replace(/[^0-9.-]/g, ''));
      const saving = Math.round((amount(compare) - amount(current)) * 100) / 100;
      let badge = list.querySelector('.NyxelSummarySavings');
      if (!current || !compare || !Number.isFinite(saving) || saving <= 0) {
        if (badge) badge.remove();
        return;
      }
      if (!badge) {
        badge = document.createElement('span');
        badge.className = 'NyxelSummarySavings';
        list.append(badge);
      }
      const formatted = new Intl.NumberFormat('en-US', {
        style: 'currency', currency: window.Shopify?.currency?.active || 'USD',
        minimumFractionDigits: Number.isInteger(saving) ? 0 : 2,
        maximumFractionDigits: 2
      }).format(saving);
      const text = 'Save ' + formatted;
      if (badge.textContent !== text) badge.textContent = text;
    }
    const observer = new MutationObserver(refresh);
    observer.observe(list, { childList: true, subtree: true, characterData: true });
    instances.set(root, observer);
    refresh();
  }
  function initialize() { document.querySelectorAll(selector).forEach(mount); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
  else initialize();
  document.addEventListener('shopify:section:load', initialize);
  document.addEventListener('shopify:section:unload', event => {
    for (const [root, observer] of instances) {
      if (event.target.contains(root)) { observer.disconnect(); instances.delete(root); }
    }
  });
})();
